import { type ApplicationModes } from '../../constants/application-modes';

export const onKeyboardPress: (
	pressType: string,
	title: string,
	applicationMode: ApplicationModes,
) => {
	type: string;
	data: {
		actionSubject: string;
		action: string;
		source: string;
		attributes: {
			pressType: string;
			title: string;
			mode: ApplicationModes;
		};
	};
} = (pressType: string, title: string, applicationMode: ApplicationModes) => {
	return {
		type: 'sendUIEvent',
		data: {
			actionSubject: 'keyboard',
			action: 'pressed',
			source: 'fullPageSearch',
			attributes: {
				pressType,
				title,
				mode: applicationMode,
			},
		},
	};
};

export const onHighlightedWithKeyboard: (
	index: number,
	applicationMode: ApplicationModes,
) => {
	type: string;
	data: {
		actionSubject: string;
		action: string;
		source: string;
		attributes: {
			index: number;
			mode: ApplicationModes;
		};
	};
} = (index: number, applicationMode: ApplicationModes) => {
	return {
		type: 'sendUIEvent',
		data: {
			actionSubject: 'keyboard',
			action: 'highlighted',
			source: 'fullPageSearch',
			attributes: {
				index,
				mode: applicationMode,
			},
		},
	};
};
